import { getAccessToken } from "@awtoban/shared";
import { createRootRoute, createRoute, Outlet, redirect } from "@tanstack/react-router";
import { LoginPage } from "../features/auth/LoginPage";
import { CompaniesPage } from "../features/companies/CompaniesPage";
import { DashboardPage } from "../features/dashboard/DashboardPage";
import { IntegrityPage } from "../features/integrity/IntegrityPage";
import { OperatorsPage } from "../features/operators/OperatorsPage";
import { ComparePage } from "../features/pricing/ComparePage";

const rootRoute = createRootRoute({ component: Outlet });

const requireAuth = () => {
  if (!getAccessToken()) throw redirect({ to: "/login" });
};

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: DashboardPage,
  beforeLoad: requireAuth,
});

const operatorsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/operators",
  component: OperatorsPage,
  beforeLoad: requireAuth,
});

const companiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/companies",
  component: CompaniesPage,
  beforeLoad: requireAuth,
});

const integrityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integrity",
  component: IntegrityPage,
  beforeLoad: requireAuth,
});

const compareRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/pricing/compare",
  component: ComparePage,
  beforeLoad: requireAuth,
});

export const routeTree = rootRoute.addChildren([
  loginRoute,
  dashboardRoute,
  operatorsRoute,
  companiesRoute,
  integrityRoute,
  compareRoute,
]);
